import Vue from 'vue';
import Vuex from 'vuex';
import {Store} from 'vuex'
import userStore from './userStore';
import baseConfig from './baseConfig';
import getters from './getters'

Vue.use(Vuex);

export default new Store({
  state: {
    metainfo: '秦淮区知识产权信息服务平台'
  },
  getters,
  mutations: {},
  modules: {
    userStore,
    baseConfig
  },
  actions: {},
  plugins: []
});




// WEBPACK FOOTER //
// ./src/store/index.js